// Options Analysis worker API — a SEPARATE backend process (options_service/options_server.py).
// In production it is served on the same origin under /api/options (nginx); in development set
// REACT_APP_OPTIONS_BACKEND_URL (e.g. http://localhost:8010). The same JWT as the main API is
// sent, and the same 401 handling applies.
import axios from "axios";
import { TOKEN_KEY } from "@/lib/api";

const BASE = process.env.REACT_APP_OPTIONS_BACKEND_URL || process.env.REACT_APP_BACKEND_URL;
export const OPTIONS_ENABLED = process.env.REACT_APP_OPTIONS_ENABLED !== "false";
// Options HEDGING (execution module, main backend /api/options-hedge) - separate flag
export const OPTIONS_HEDGE_ENABLED = process.env.REACT_APP_OPTIONS_HEDGE_ENABLED !== "false";
// Iron Condor scanner (read-only, Iron Condor plan Phase 1) - OFF unless the build opts in
export const IRON_CONDOR_ENABLED = process.env.REACT_APP_IRON_CONDOR_ENABLED === "true";
// Iron Condor SHADOW trading (Phase 3, main backend /api/iron-condor) - OFF unless the build opts in
export const IRON_CONDOR_TRADING_ENABLED = process.env.REACT_APP_IRON_CONDOR_TRADING_ENABLED === "true";
// Box Spread SHADOW trades (main backend /api/box-spread): the SHADOW Trades view and the Box Builder's Create button.
export const BOX_SPREAD_TRADING_ENABLED = process.env.REACT_APP_BOX_SPREAD_TRADING_ENABLED === "true";

const optionsApi = axios.create({ baseURL: `${BASE}/api/options` });

optionsApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

optionsApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem(TOKEN_KEY)) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function optionsError(e) {
  const d = e?.response?.data;
  if (typeof d?.detail === "string") return d.detail;
  if (typeof d?.message === "string") return d.message;
  if (!e?.response) return "Options Analysis service is not reachable";
  return e?.message || "Something went wrong";
}

export default optionsApi;
